import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Button, Form } from 'antd';

import { BackButton } from '../../components/BackButton';
import { usePersonalisedReportContext } from '../../../context';
import { CreateOrUpdateCharacteristic } from '../../../context/types';
import { useCreateCharacteristicResult, useUpdateCharacteristicResult } from './hooks';
import { CharacteristicsFormFields, CreateOrUpdateService } from '../../../context/services';

const { useFormInstance } = Form;

export const Footer: React.FC = () => {
	const form = useFormInstance();
	const {
		organization_id,
		company_id,
		personalisedReport,
		step_setting_id,
		report_id,
		handleNextStep,
		handlePreviousStep,
		scrollToError
	} = usePersonalisedReportContext();

	const { mutateAsync: createResult, isLoading: creatingReport } = useCreateCharacteristicResult();
	const { mutateAsync: updateResult, isLoading: updatingReport } = useUpdateCharacteristicResult();

	function handlePreviousClick(): void {
		handlePreviousStep();
	}

	async function handleNextClick(): Promise<void> {
		try {
			const validation = await form.validateFields();
			if (validation) {
				const values: CharacteristicsFormFields = await form.getFieldValue(['characteristics']);
				const createOrUpdateService = new CreateOrUpdateService();
				const payload = createOrUpdateService.mapPayload(values, {
					report_id,
					company_id,
					organization_id,
					step_setting_id,
					result_id: personalisedReport.result_id,
					workstation_id: personalisedReport.basic_information?.workstation_id
				});
				if (createOrUpdateService.isCharacteristicPayload(payload)) {
					if (alreadyHasResult()) {
						return await update(payload);
					}
					const report = await createResult(payload);
					if (report.id) {
						handleNextStep();
					}
				}
			}
		} catch (error: any) {
			scrollToError(error);
		}
	}

	function alreadyHasResult(): boolean {
		return !!personalisedReport.characteristics?.id;
	}

	async function update(payload: CreateOrUpdateCharacteristic): Promise<void> {
		const report = await updateResult({
			...payload,
			characteristic_id: personalisedReport.characteristics?.id
		});
		if (report.id) {
			handleNextStep();
		}
	}

	return (
		<Row>
			<Col xs={24} style={{ marginTop: '2rem' }}>
				<Row justify="center">
					<BackButton onPreviousClick={handlePreviousClick} disabled={creatingReport || updatingReport} />
					<Col>
						<Button
							type="primary"
							htmlType="submit"
							onClick={handleNextClick}
							loading={creatingReport || updatingReport}
							disabled={creatingReport || updatingReport}
						>
							{I18n.get('Next')}
						</Button>
					</Col>
				</Row>
			</Col>
		</Row>
	);
};
